<template>
	<div class="topbar">
		<div class="topbar-title">
			<div class="eyebrow"><span v-text="$t('cardapio_title')"></span></div>
			<h1><span v-text="$t('dashboard_title')"></span></h1>
		</div>
		<div class="topbar-selects">
			<select :value="filial" class="dg-select" @change="onFilialChange">
				<option value="geral">{{ $t('dashboard_gestao_select_geral') }}</option>
				<option v-for="f in filiais" :key="f.id" :value="f.id">{{ f.nome }}</option>
			</select>
			<MonthRangePicker
				:value="periodo"
				:min="periodoMin"
				:max="periodoMax"
				:quick-presets="periodoQuickPresets"
				@input="onPeriodoChange"
				@limit-exceeded="onPeriodoLimitExceeded"
			/>
			<button
				type="button"
				class="dg-export-button"
				:disabled="exportDisabled"
				@click="$emit('export')"
			>
				<i class="fas fa-file-excel"></i>
				<span>{{ $t('export') }}</span>
			</button>
		</div>
	</div>
</template>

<script>
import MonthRangePicker from '../common/MonthRangePicker.vue';

export default {
	name: 'DashboardGestaoHeader',
	components: { MonthRangePicker },
	props: {
		filial: { type: String, default: 'geral' },
		periodo: { type: Object, default: () => ({ start: '', end: '' }) },
		periodoMin: { type: String, default: '' },
		periodoMax: { type: String, default: '' },
		filiais: { type: Array, default: () => [] },
		exportDisabled: { type: Boolean, default: false },
	},
	computed: {
		periodoQuickPresets() {
			return [
				{ key: 'past-3', label: this.$t('dashboard_gestao_quick_3m'), months: 3, mode: 'past' },
				{ key: 'past-6', label: this.$t('dashboard_gestao_quick_6m'), months: 6, mode: 'past' },
				{ key: 'past-12', label: this.$t('dashboard_gestao_quick_12m'), months: 12, mode: 'past' },
				{ key: 'future-6', label: this.$t('dashboard_gestao_quick_next_6m'), months: 6, mode: 'future' },
			];
		},
	},
	methods: {
		onFilialChange(e) {
			this.$emit('update:filial', e.target.value);
		},
		onPeriodoChange(periodo) {
			this.$emit('update:periodo', periodo);
		},
		onPeriodoLimitExceeded(payload) {
			this.$emit('limit-exceeded', payload);
		},
	},
};
</script>

<style scoped lang="less">
@crimson: #d81f45;
@card: #ffffff;
@line: #e7e9f0;
@ink: #1a2036;
@fontFamily: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;

.topbar {
	display: flex;
	align-items: flex-end;
	justify-content: space-between;
	flex-wrap: wrap;
	gap: 12px;
	margin-bottom: 18px;

	.eyebrow {
		font-size: 12px;
		color: @crimson;
		font-weight: 700;
		letter-spacing: 0.4px;
		text-transform: uppercase;
	}

	h1 {
		margin: 2px 0 0;
		font-size: 23px;
		font-weight: 800;
		letter-spacing: -0.6px;
		color: @ink;
	}

	.topbar-selects {
		display: flex;
		gap: 10px;
		align-items: center;
	}
}

.dg-select {
	appearance: none;
	background: @card;
	border: 1px solid @line;
	border-radius: 9px;
    width: fit-content;
	padding: 9px 32px 9px 12px;
	font-size: 13px;
	font-weight: 600;
    max-width: 260px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
	color: @ink;
	cursor: pointer;
	font-family: @fontFamily;
	outline: none;
	background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%236b7280' stroke-width='2'%3E%3Cpath d='M3 4.5L6 7.5L9 4.5'/%3E%3C/svg%3E");
	background-repeat: no-repeat;
	background-position: right 10px center;
}

.dg-export-button {
	display: inline-flex;
	align-items: center;
	gap: 7px;
	background: @card;
	border: 1px solid @crimson;
	border-radius: 9px;
	padding: 9px 13px;
	color: @crimson;
	font-size: 13px;
	font-weight: 700;
	font-family: @fontFamily;
	cursor: pointer;

	&:hover:not(:disabled) {
		color: @ink;
		border-color: @ink;
	}

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
}
</style>
